import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, IconButton, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getNotificationIcon } from '../../../../shared/functions/getNotificationIcon';
import { getNotificationValue } from '../../../../shared/functions/getNotificationValue';
import { getRGBAColor } from '../../../../shared/functions/getRGBAColor';
import { INotifications } from '../../../../shared/interfaces/notifications/INotifications';
import i18n from '../../../../utils/localization/i18n';

interface IProps {
  notification: INotifications;
  correctPalette: {
    primary: { main: string; light: string; dark: string };
    secondary: { main: string };
    info: { main: string };
    background: { default: string; paper: string };
    text: { primary: string; gray: string };
    error: {};
    warning: {};
    success: {};
    expense: {};
  };
  isDetail?: boolean;
}

const NotificationItem: React.FC<IProps> = ({
  notification,
  correctPalette,
  isDetail = false,
}) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginLeft: '10px',
          fontSize: '14px',
        }}
      >
        <IconButton
          sx={{
            display: 'flex',
            padding: '5px',
            marginRight: '10px',
            backgroundColor: getRGBAColor('--primaryColor', 0.08),
            borderRadius: '10px',
            color: 'var(--primaryColor)',
          }}
        >
          {getNotificationIcon(notification?.notificationType)}
        </IconButton>
        {t(`notification.${notification?.notificationType}`, {
          name: getNotificationValue(notification),
        })}
        {!notification.isSeen && (
          <FiberManualRecordIcon
            fontSize={'small'}
            color={'primary'}
            sx={{ position: 'absolute', top: 0, right: 0 }}
          />
        )}
      </Typography>
      {isDetail && (
        <Typography variant={'body2'} color={'gray'}>
          {moment(notification?.createdAt)
            .locale(i18n?.language || 'en')
            ?.fromNow()}
        </Typography>
      )}
    </Box>
  );
};

export default NotificationItem;
